import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card ,Table} from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { getAllProduct } from "../product/productAction";
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { useParams, useNavigate } from 'react-router-dom';
import { productcommissionModification, getSingleProductCommission } from "./commissionAction";
import RemarkModel from './RemarkModal';
import Swal from 'sweetalert2';
import { FaEye, FaArrowLeft,FaArrowAltCircleRight, FaTrash, FaPlus} from 'react-icons/fa';

const Modifycommission = () => {
  const dispatch = useDispatch();
  const { name } = useParams();
  const { name1 } = useParams();
  const { name2 } = useParams();
  const { idd } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState("");
  const [productid,setProductid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [servicetypeid,setServicetypeid]= useState('');
  const { products } = useSelector((state) => state.productList);
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { subproducts2 } = useSelector((state) => state.subproductList);
  const { mmessage } = useSelector((state) => state.productcommissionList);

  const [subproducts22, setSubproducts22] = useState([]);
  const [commissiondata, setCommissionData] = useState([]);
console.log("commissiondata",commissiondata)
const [isAlive,setIsAlive] = useState(true);
  const [commissiondata2, setCommissionData2] = useState([]);
  const [allCommission, setAllCommission] = useState("");
  const [applyToAll, setApplyToAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const productcommissionData = useSelector((state) => state.productcommissionList);



  const handleOpenRemarkModel = (index) => {
    setSelectedRowIndex(index);
    setOpen(true);
  };
  
  const firstUpdate = useRef(true);
 
  

  



     const { register, handleSubmit, formState: { errors } } = useForm();

    const loadProductCommission = async (idd) => {
  const response = await dispatch(getSingleProductCommission(idd));
  if (response && response.commissions) {
    const commissionDataArray = response.commissions.map((data) => ({
      id: data.id,
      commission: data.commission,
      commissiontype: data.commission_type,
      product_id: data.product_id,
      remarks: data.remarks,
      serviceTypeId: data.service_type_id,
      status: data.status,
      subproduct_name: data.subproduct_name,
    }));

    setCommissionData(commissionDataArray);
  }
};

useEffect(() => {
  if (idd) {
    loadProductCommission(idd);
  }
}, [idd]);
useEffect(() => {
  const cData = JSON.parse(JSON.stringify(productcommissionData.commissions));
  setCommissionData(cData);
}, [productcommissionData]);


  
   const cData = JSON.parse(JSON.stringify(productcommissionData.commissions));
    
  //  const handleOnChange = e => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   // console.log('name '+name); 
  //   //console.log('value '+value); 
  //   setCommissionData({ ...commissiondata, [name]: value });
  //   /* setRole(prevState => ({
  //     role:{
  //       ...prevState.role,
  //       [name]: value
  //     }
  //   })); */
  // };



//  sss

  
  // ...
  
  const handleOnChange = (index, e) => {
    console.log("index",index)
    console.log("newCommission",e)
    const updatedCommissionData = [...commissiondata];
    updatedCommissionData[index] = {
      ...updatedCommissionData[index],
      commission_type: e,
      status:"Pending"
    };
    setCommissionData(updatedCommissionData);
    setApplyToAll(false);
  };
  
  // ...
  
  
  
  


  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllServiceType());
    dispatch(getAllMainSubProduct());
    loadProductCommission(idd); // Load the product commission data on component mount
    // return () => setIsAlive(false);
  }, [mmessage]);

 
  const handleApplyToAllChange = (event) => {
    const checked = event.target.checked;
    const newSubproducts = commissiondata.map((subproduct) => ({
      ...subproduct,
      commission: checked ? allCommission : subproduct.commission,
      status: checked ? "Pending" : "Pending"
    }));
    setCommissionData(newSubproducts);
    setApplyToAll(checked);
  };
  const handleSubproductCommissionChange = (index, newCommission) => {
    console.log("index",index)
    console.log("newCommission",newCommission)
    const updatedCommissionData = [...commissiondata];
    updatedCommissionData[index] = {
      ...updatedCommissionData[index],
      commission: newCommission,
      status: "Pending"
    };
    setCommissionData(updatedCommissionData);
    setApplyToAll(false);
  };


  // const handleOnSubmit = (event) => {
  //   event.preventDefault();
  //   // Save the commission data to the database

  //   const { id, commission, commissiontype,serviceTypeId,status,product_id
  //   } = commissiondata;

  //   const commissionUpdation1 = {
  //     id, commission, commissiontype,serviceTypeId,status,product_id
  //   };
  //   dispatch(productcommissionModification(commissionUpdation1));
  //   Swal.fire({
  //     title: 'Updated!',
  //     text: 'Commission Updated Successfully',
  //     icon: 'success',
  //     confirmButtonText: 'Okay'
  //   })
  
    

    
  // };

  const onBack = () => {
   
    //console.log('select role '+id);
    navigate("/" + name1 + "/" +name2); 
 }


  const handleOnSubmit = async (event) => {
    event.preventDefault();

    const response = await dispatch(getSingleProductCommission(idd));
    // console.log("responseeeee",response.payload)
  
    const commissionDataArray2 = response.payload.map((data) => ({
      id: data.id,
      commission: data.commission,
      commissiontype: data.commission_type,
      serviceTypeId: data.service_type_id,
      status: data.status,
      product_id: data.product_id,
    }));
    const commissionData = commissiondata.map((subproduct) => ({
      id: subproduct.id,
      commission: subproduct.commission,
      commissiontype: subproduct.commission_type,
      serviceTypeId: subproduct.service_type_id,
      status: subproduct.status,
      product_id: subproduct.product_id,
    }));
    if (JSON.stringify(commissionData) === JSON.stringify(commissionDataArray2)) {
      Swal.fire('No changes made!', '', 'warning');
      return;
    }else{
      try {
        // Perform any necessary validation before submitting the form
        // ...
    
        // Prepare the data to be submitted
        const commissionData = commissiondata.map((subproduct) => ({
          id: subproduct.id,
          commission: subproduct.commission,
          commissiontype: subproduct.commission_type,
          serviceTypeId: subproduct.service_type_id,
          status: subproduct.status,
          product_id: subproduct.product_id,
        }));
    
        // Dispatch an action to update the commission data in the database
        await dispatch(productcommissionModification(commissionData));
        // setIsAlive(true)
        // Show a success message to the user
        Swal.fire({
          title: 'Updated!',
          text: 'Commission Updated Successfully',
          icon: 'success',
          confirmButtonText: 'Okay'
        });
    
        // Redirect or perform any additional actions after successful submission
        // ...
        navigate("/" + name1 + "/" +name2)
    
      } catch (error) {
        // Handle any errors that occurred during form submission
        console.error(error);
        // Display an error message to the user
        Swal.fire({
          title: 'Error',
          text: 'An error occurred while updating commission',
          icon: 'error',
          confirmButtonText: 'Okay'
        });
      }



    }
  
    
  };
  

  return (
    // <Container className="my-4 mx-4 container-xl ">

    // <Card   style={{marginLeft:'210px',marginRight:'-100px'}}>
    //   <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Modify Commission Details</h4></Card.Header>
     
    //   <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>


    //   <Card.Body>
    <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman',fontWeight:'600' }}>Modify Commission Details</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                        <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div> 
   
                        </Row>
                        <br />
        
        <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}> {/* handleOnSubmit() */}

          <Row className="mb-3">
          
           
   
           
            {cData?.length > 0 ?<> 
    <div>
       
          <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sub Product Name</th>
            <th>Commission Type</th>
            <th>Commission Amount</th>
          </tr>
        </thead>
        <tbody>
    {commissiondata.map((subproduct, index) => (
      <tr key={index}>
        <td>{subproduct.subproduct_name}</td>
        <td>
          <Form.Group as={Col} controlId="formGridStatus">
            <Form.Select
              required
              name="status"
              onChange={(e) => handleOnChange(index, e.target.value)}
              value={subproduct.commission_type}
            >
              <option value="">Choose..</option>
              <option value="Percentage">Percentage</option>
              <option value="Fixed">Fixed</option>
            </Form.Select>
          </Form.Group>
        </td>
        <td>
          <input
            type="number"
            min="0"
            max="100"
            style={{ width: "220px" }}
            value={subproduct.commission}
            onChange={(event) =>
              handleSubproductCommissionChange(index, event.target.value)
            }
          />
        </td>
      </tr>
    ))}
        <tr>
            <td colSpan={2}>
              <label>
                <input
                  type="checkbox"
                  checked={applyToAll}
                  onChange={handleApplyToAllChange}
                />&nbsp;
                Apply to All
              </label>
            </td>
            <td>
              <input
                type="number"
                min="0"
                max="100"
                value={allCommission}
                // disabled={!applyToAll}
                style={{width:"220px"}}
                onChange={(event) => setAllCommission(event.target.value)}
              />
            </td>
          </tr>
    {/* Rest of the code */}
  </tbody>
      </Table>
    </div>
  </> : <><br /><h4 style={{textAlign:"center",color:"red"}}>No Data Found..</h4><br /><p style={{textAlign:"center"}}>[Add Sub Product]</p></>}
          </Row>
          <div class="d-grid  col-2 mx-auto">
          <Button variant="primary" type="submit" disabled={commissiondata?.length === 0} className='align-middle'>
            Submit
          </Button>
          </div>

        </Form>
        </div>
        </div>
        </div>
      
  );
};

export default Modifycommission;
